module.exports = __webpack_public_path__ + "img/tennis.1c5cfea6.svg";